import React from 'react';

import cn from 'classnames';

import Spin from '../../../../shared/components/spin';
import { i18n } from '../../../../shared/helpers/i18n';
import css from './index.css';

interface Props {
    displayName?: string;
    isVideoReady?: boolean;
    className?: string;
    isSelf?: boolean;
}

export const ParticipantSharingPreloader: React.FC<Props> = (props) => {
    const { displayName, isVideoReady, className, isSelf } = props;

    if (isVideoReady) {
        return null;
    }

    return (
        <div className={cn(css.SharingPreloaderWrapper, className)}>
            <div className={css.Preloader}>
                <Spin progress size="xl" color="white" />
            </div>
            <div className={css.Title}>
                {isSelf
                    ? i18n('share-screen', 'self-starts-demonstration')
                    : i18n('share-screen', 'user-starts-demonstration', { name: displayName || '' })}
            </div>
            <div className={css.Message}>{i18n('share-screen', 'please-wait-long')}</div>
        </div>
    );
};
